import { useParams } from 'react-router'
import { PERMISSION_ACTION_EDIT, PERMISSION_ENTITY_SOURCE_DOCUMENT } from '@klear/constants'
import { DocumentReviewWorkspace } from '@/app/document-review/document-review-workspace'
import { useAgentContext } from '@klear/ui/contexts/agent-context'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { useTraders } from '@klear/ui/hooks/use-traders'

export default function DocumentReviewDetail() {
  const { processingId } = useParams<{ processingId: string }>()
  const { user } = useAuth()
  const { traders } = useTraders()
  const canEdit = user.hasPermission(PERMISSION_ENTITY_SOURCE_DOCUMENT, PERMISSION_ACTION_EDIT)
  useAgentContext([`Review ${processingId ?? ''} (read_document_review).`])

  return (
    <DocumentReviewWorkspace
      key={processingId ?? ''}
      processingId={processingId ?? ''}
      canEdit={canEdit}
      traders={traders?.map((trader) => ({ id: trader.id, name: trader.name })) ?? []}
    />
  )
}
